import React from "react";
import HeaderAdmin from "../HeaderAdmin";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div
      className="min-h-screen relative overflow-x-hidden"
      style={{
        background: `
          radial-gradient(circle at 50% 40%, rgba(255,255,255,0.98) 0%, rgba(245,249,255,0.88) 50%, rgba(225,234,247,0.4) 75%, rgba(210,222,240,0.2) 95%),
          radial-gradient(130% 130% at 18% 82%, rgba(170,200,240,0.16), transparent 55%),
          radial-gradient(120% 120% at 82% 86%, rgba(150,190,235,0.12), transparent 55%),
          linear-gradient(135deg, rgba(240,246,255,0.8) 0%, rgba(232,240,252,0.7) 50%, rgba(225,236,250,0.6) 100%)
        `,
        color: "#e8eeff",
      }}
    >
      <HeaderAdmin />
      <main className="px-5 pb-5" style={{ color: "#0e1b38" }}>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
